// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"b367cd30","795":"77f36a48","835":"b7f230e5"}[chunkId] + ".chunk.js";
};